const TAG_OVERRIDES = {
  'd&d': 'D&D',
  tf2: 'TF2',
  pfp: 'PFP',
  pvz: 'PvZ',
  nes: 'NES',
  snes: 'SNES',
  mxn: 'MXN',
  cad: 'CAD',
  cny: 'CNY',
  usd: 'USD',
  zyra: 'Zyra',
  halo: 'Halo',
  zelda: 'Zelda',
  shantae: 'Shantae',
  splatoon: 'Splatoon',
};

function titleCaseWord(word) {
  const lower = word.toLowerCase();
  if (TAG_OVERRIDES[lower]) return TAG_OVERRIDES[lower];
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function canonicalTag(tag) {
  const trimmed = String(tag).trim();
  if (!trimmed) return '';

  const lower = trimmed.toLowerCase();
  if (lower === 'scene' || lower === 'scenes') return 'Scene';
  if (TAG_OVERRIDES[lower]) return TAG_OVERRIDES[lower];

  return lower
    .split(/\s+/)
    .map(titleCaseWord)
    .join(' ');
}

export function normalizeTags(tags) {
  if (!tags?.length) return [];

  return [
    ...new Set(
      tags
        .flatMap((tag) => String(tag).split(','))
        .map((tag) => canonicalTag(tag))
        .filter(Boolean)
    ),
  ];
}

export function itemHasTag(item, tag) {
  return normalizeTags(item.tags).includes(canonicalTag(tag));
}
